export class ExtendFormie {
    constructor(settings = {}) {
        this.formHandle = settings.config.formHandle
        this.$form = settings.$form
        this.form = this.$form.form
        this.$recaptchaPlaceholder = this.$form.querySelector('[data-recaptcha-placeholder]') ?? false
        this.$unloadWithoutWarningLinks = [...this.$form.querySelectorAll('[data-unload-without-warning]')]
        this.recaptchaBranding = this.$form.dataset.recaptchaBranding ?? null




        /*
        if (this.$recaptchaPlaceholder && this.recaptchaBranding) {
            this.addRecaptchaBranding()         
         }
         */

        this.registerAdditionallyFormieValidation()

        if (this.form.settings.pages.length > 1) {
            this.updateProgressIndexes()
        }

        if (this.$unloadWithoutWarningLinks.length) {
            this.bindUnloadWithoutWarning()
        }

    }


    addRecaptchaBranding() {
        const recaptchaInfoText = document.createElement('p')
        recaptchaInfoText.classList = 'form__infos subtitle-small'
        recaptchaInfoText.innerHTML = this.recaptchaBranding
        this.$recaptchaPlaceholder.insertAdjacentElement('afterend', recaptchaInfoText)
    }

    /**
     * Update the index left to the progress bar
     */
    updateProgressIndexes() {
        this.$form.addEventListener('onFormiePageToggle', (event) => {
            const data = event.detail.data
            const $indexCurrent = this.$form.querySelector('[data-fui-progress-index-current]')
            const $totalPages = this.$form.querySelector('[data-fui-progress-index-total-pages]')

            if ($indexCurrent && $totalPages && (data.nextPageIndex || data.nextPageIndex === 0)) {
                $indexCurrent.textContent = this.leftPadTwo(parseInt(data.nextPageIndex, 10) + 1)
                $totalPages.textContent = this.leftPadTwo(data.totalPages)
            }
        })
    }

    registerAdditionallyFormieValidation() {

        this.$form.addEventListener('registerFormieValidation', (e) => {

            e.detail.validatorSettings.messages.patternMismatch = {
                ...e.detail.validatorSettings.messages.patternMismatch,
                ...this.extendedPatternCheck()
            }

            e.detail.validatorSettings.messages = {
                ...e.detail.validatorSettings.messages,
                ...this.customMessage(),
            };

            e.detail.validatorSettings.customValidations = {
                ...e.detail.validatorSettings.customValidations,
                ...this.customValidations(),
            }

        })
    }

    /*
    * Allow link to unload without warning
    * work around: update the hash to trick formie 
    */
    bindUnloadWithoutWarning() {
        this.$unloadWithoutWarningLinks.map(el => {
            el.addEventListener('click', () => this.form.formTheme.updateFormHash())
        })
    }

    extendedPatternCheck() {
        const t = this.t
        return {
            default(field) {
                const pattern = field.getAttribute('pattern')
                const patternErrorMessage = field.getAttribute("data-pattern-error-message") 
                const reg = new RegExp(pattern)
                const matches = []

                field.value.split('').map(letter => {
                    if (!reg.test(letter)) {
                        matches.push(letter)
                    }
                })

                return patternErrorMessage ?? t('Please match the requested format.', {
                    pattern: matches ? matches.join(', ') : pattern,
                })
            },
        }
    }

    customMessage() {
        const t = this.t
        return {
            checkForMandatoryConnection(field) {
                return field.dataset.mandatoryConnection;
            },
            minDateField(field) {
                return field.dataset.minDateFieldError ?? t('The end date must be later than the start date.')
            }
        };
    }

    /* Add custom validations for a given form   */
    customValidations() {
        const t = this.t
        const $form = this.$form
        let customValidations = {}

        switch (this.formHandle) {
            case 'ewlComplexTemporaryConnection':

                // custom validation
                // the field directConnection need to be set or have one of the plug selected.
                customValidations = {
                    ...customValidations,
                    checkForMandatoryConnection(field) {
                        const mandatoryConnection = field.dataset.mandatoryConnection ?? null
                        if (mandatoryConnection) {
                            // is the field directConnection not empty
                            if (field.value) {
                                return false
                            }

                            // check if the user has selected on of the plug
                            const rentalStoreFields = [...$form.querySelectorAll('[data-field-type="rental-store"] input')]
                            return !rentalStoreFields.filter(field => field.value > 0).length

                        }
                        return false
                    }
                }

            default:

                customValidations = {
                    ...customValidations,
                    // add to the target field following data attr:
                    // data-min-date-field="handleOfTheTargetField"
                    // data-min-date-field-error="Das Enddatum muss nach dem Startdatum liegen."
                    minDateField(field) {
                        const minDateFieldname = field.dataset.minDateField ?? null
                        if (!minDateFieldname) {
                            return false
                        }
                        // find the target field
                        const targetField = $form.querySelector(`[name$="[${minDateFieldname}][datetime]"]`)

                        // get the flatpickr object for both field
                        const currentFlatpickr = field.previousElementSibling._flatpickr ?? false
                        const targetFlatpickr = targetField._flatpickr ?? false

                        // if set do a comparaison
                        if (currentFlatpickr && targetFlatpickr) {

                            const currentFlatpickrSelectedDates = currentFlatpickr.selectedDates[0] ?? false
                            const targetFlatpickrSelectedDates = targetFlatpickr.selectedDates[0] ?? false

                            return currentFlatpickrSelectedDates < targetFlatpickrSelectedDates

                        }

                        return true


                    }
                }

        }

        //console.log(customValidations);

        return customValidations;
    }

    t(string, replacements = {}) {
        if (window.FormieTranslations) {
            string = window.FormieTranslations[string] || string
        }

        return string.replace(/{([a-zA-Z0-9]+)}/g, (match, p1) => {
            if (replacements[p1]) {
                return replacements[p1]
            }

            return match
        })
    };
    /**
     * add zeros as left padded if needed
     */
    leftPadTwo(num) {
        return num.toString().padStart(2, "0")
    }

}